import React from 'react';

const socialPortfolioItems = [
  {
    id: 1,
    image: '/assets/images/social-media/social (1).webp',
    title: 'Social Media Strategy & Audience Engagement',
    category: 'Meta Campaigns & Growth'
  },
  {
    id: 2,
    image: '/assets/images/social-media/social (2).webp',
    title: 'Viral Content Creation & Brand Presence',
    category: 'Creative Design & Reels'
  },
  {
    id: 3,
    image: '/assets/images/social-media/social (3).webp',
    title: 'High-ROI Paid Social Advertising',
    category: 'Conversion Optimization'
  }
];

function SocialMediaPortfolioSection() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section 
      className="seo-portfolio-section"
      id="social-media-portfolio"
      style={{
        backgroundColor: '#ffffff',
        borderTop: '1px solid #f1f5f9',
        borderBottom: '1px solid #f1f5f9',
        color: '#0f172a',
        padding: '7rem 0'
      }}
    >
      <div className="container">
        {/* Section Header */}
        <div className="seo-portfolio-header" style={{ textAlign: 'center', maxWidth: '880px', margin: '0 auto 4.5rem' }}>
          <div className="seo-portfolio-badge-row">
            <span className="seo-portfolio-badge">Portfolio &amp; Impact</span>
            <div className="seo-portfolio-badge-line"></div>
          </div>

          <h2 
            className="seo-portfolio-title"
            style={{
              color: '#0f172a',
              fontSize: '2.85rem',
              fontWeight: '800',
              lineHeight: '1.25',
              marginBottom: '1.4rem'
            }}
          >
            Social Media Management Services That <span style={{ color: '#c40a0a' }}>Bring Quality Outcomes</span>
          </h2>

          <p 
            className="seo-portfolio-subtitle"
            style={{
              color: '#475569',
              fontSize: '1.04rem',
              lineHeight: '1.76'
            }}
          >
            Experts Communication believes in client satisfaction and quality services. As a leading BPO &amp; IT company, we help many businesses in multiple industries to increase their revenue. We want to create a long-term and fruitful relationship with our clients to sustain their online growth, because we only believe in presenting results and growth.
          </p>
        </div>

        {/* 3-Column Portfolio Cards Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2.2rem'
          }}
        >
          {socialPortfolioItems.map((item) => (
            <div
              key={item.id}
              onClick={handleConsultationClick}
              style={{
                cursor: 'pointer',
                borderRadius: '24px',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 14px 35px rgba(0, 0, 0, 0.08)',
                border: '1px solid #e2e8f0',
                transition: 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.borderColor = '#c40a0a';
                e.currentTarget.style.boxShadow = '0 20px 45px rgba(196, 10, 10, 0.18)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.boxShadow = '0 14px 35px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ overflow: 'hidden', borderRadius: '24px' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    transition: 'transform 0.5s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.03)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SocialMediaPortfolioSection;
